<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="6">
        <v-card
          flat
          class="mb-6"
          style="border: 2px dashed #e0e0e0; border-radius: 10px;">
          <v-card-text>
            <ValidationProvider 
              name="Nomor Surat" 
              rules="required" 
              v-slot="{ errors, valid }">
              <div class="body-2 mb-2">
                <span class="red--text">*</span>
                Nomor Surat
                <span class="error--text">
                  (wajib diisi)
                </span>
              </div>
              
              <v-text-field
                filled
                rounded
                dense
                :color="set_color"
                
                placeholder="Contoh. SRT/PRK/20240102/0001"
                hide-details

                v-model="form.number"
                :success="valid"
                :error-messages="errors"
                required
                class="mb-6"
                style="border-radius: 10px;">
                <template v-slot:append-outer>
                  <div v-if="errors.length > 0">
                    <v-tooltip top color="#ff5252">
                      <template v-slot:activator="{ on }">
                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                      </template>
                      
                      Nomor Surat {{ errors[0] }}
                    </v-tooltip>
                  </div>

                  <div v-if="form.number !== '' && valid">
                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                  </div>
                </template>
              </v-text-field>
            </ValidationProvider>

            <ValidationProvider 
              name="Tujuan Penerima" 
              rules="required" 
              v-slot="{ errors, valid }">
              <div class="body-2 mb-2">
                <span class="red--text">*</span>
                Tujuan Penerima
                <span class="error--text">
                  (wajib diisi)
                </span>
              </div>
              
              <v-text-field
                filled
                rounded
                dense
                :color="set_color"
                
                placeholder="Contoh. John Doe"
                hide-details

                v-model="form.for"
                :success="valid"
                :error-messages="errors"
                required
                class="mb-3"
                style="border-radius: 10px;">
                <template v-slot:append-outer>
                  <div v-if="errors.length > 0">
                    <v-tooltip top color="#ff5252">
                      <template v-slot:activator="{ on }">
                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                      </template>
                      
                      Tujuan Penerima {{ errors[0] }}
                    </v-tooltip>
                  </div>

                  <div v-if="form.for !== '' && valid">
                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                  </div>
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-card-text>
        </v-card>

        <ValidationProvider 
          name="Nama File" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Nama File
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. Surat Menyurat"
            hide-details

            v-model="form.title"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Nama File {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.title !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>

        <ValidationProvider 
          name="Nama Pemesan" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Nama Pemesan
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. Nama Pemesan."
            hide-details

            v-model="form.template_meta_json_object.nama_pesanan"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px; width: 50%;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Nama Pemesan {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.nama_pesanan !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>  

        <ValidationProvider
          name="Unit" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Unit
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>

          <v-autocomplete
            filled
            rounded
            dense
            :color="set_color"
            hide-details
            placeholder="Contoh. UMB Boga"

            :loading="process.unit"
            
            :items="units"
            item-value="name"
            item-text="name"
            :item-color="set_color"

            v-model="form.template_meta_json_object.unit"
            :success="form.template_meta_json_object.unit !== '' && valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Unit {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.unit !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-autocomplete>
        </ValidationProvider>
        
        <div>
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Tanggal Pengantaran
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>

          <v-menu
            ref="tanggal"
            min-width="290px"
            max-width="290px"
            transition="scale-transition"
            offset-y
            :nudge-right="40"
            :close-on-content-click="false"
            v-model="picker.tanggal_mulai">
            <template v-slot:activator="{ on, attrs }">
              <ValidationProvider 
                name="Tanggal Pengantaran" 
                rules="required"
                v-slot="{ errors, valid }">
                <v-text-field
                  readonly
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Pilih Tanggal Pengantaran"
                  hide-details
                  clearable

                  @click:clear="form.template_meta_json_object.tanggal_pengantaran = null;"
                  v-on="on"
                  v-bind="attrs"

                  v-model="form.template_meta_json_object.tanggal_pengantaran"
                  :success="form.template_meta_json_object.tanggal_pengantaran !== null && valid"
                  :error-messages="errors"
                  class="mb-6"
                  style="border-radius: 10px; width: 40%;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Tanggal Pengantaran {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.template_meta_json_object.tanggal_pengantaran !== null && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </template>

            <v-date-picker 
              :color="set_color"
              v-model="form.template_meta_json_object.tanggal_pengantaran"
              @input="picker.tanggal_mulai = false">
            </v-date-picker>
          </v-menu>
        </div>

        <ValidationProvider 
          name="Waktu Pengantaran" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Waktu Pengantaran
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. 08:00"
            hide-details
            type="time"

            v-model="form.template_meta_json_object.waktu_pengantaran"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px; width: 70%;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Waktu Pengantaran {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.waktu_pengantaran !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>  

        <ValidationProvider 
          name="Tempat Pengantaran" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Tempat Pengantaran
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. Tempat Pengantaran."
            hide-details

            v-model="form.template_meta_json_object.tempat_pengantaran"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Tempat Pengantaran {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.tempat_pengantaran !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>

        <ValidationProvider 
          name="No. Hp / Telp" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            No. Hp / Telp
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. No. Hp / Telp."
            hide-details

            v-model="form.template_meta_json_object.no_telepon"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  No. Hp / Telp {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.no_telepon !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>

        <v-btn
          @click="add_item()"

          color="#444444"
          elevation="0"
          class="text-capitalize white--text mb-4"
          style="border-radius: 10px;">
          Tambah Pesanan
        </v-btn>

        <div
          v-for="(item, index) in form.template_meta_json_object.item"
          :key="index">
          <v-card
            flat
            class="pa-3 mb-6"
            style="border: 2px dashed #f0f0f0; border-radius: 10px;">
            <v-btn
              @click="form.template_meta_json_object.item.splice(index, 1)"

              icon
              style="position: absolute; top: -15px; right: -15px;">
              <v-icon
                color="red">
                mdi-close-circle
              </v-icon>
            </v-btn>

            <ValidationProvider 
              name="Nama Produk" 
              rules="required" 
              v-slot="{ errors, valid }">
              <div class="body-2 mb-2">
                <span class="red--text">*</span>
                Nama Produk
                <span class="error--text">
                  (wajib diisi)
                </span>
              </div>
              
              <v-text-field
                filled
                rounded
                dense
                :color="set_color"
                
                placeholder="Contoh. Nama Produk"
                hide-details

                v-model="item.nama"
                :success="valid"
                :error-messages="errors"
                required
                class="mb-6"
                style="border-radius: 10px;">
                <template v-slot:append-outer>
                  <div v-if="errors.length > 0">
                    <v-tooltip top color="#ff5252">
                      <template v-slot:activator="{ on }">
                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                      </template>
                      
                      Nama Produk {{ errors[0] }}
                    </v-tooltip>
                  </div>

                  <div v-if="item.nama !== '' && valid">
                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                  </div>
                </template>
              </v-text-field>
            </ValidationProvider>

            <ValidationProvider 
              name="Detail Produk" 
              rules="required" 
              v-slot="{ errors, valid }">
              <div class="body-2 mb-2">
                <span class="red--text">*</span>
                Detail Produk
                <span class="error--text">
                  (wajib diisi)
                </span>
              </div>
              
              <v-text-field
                filled
                rounded
                dense
                :color="set_color"
                
                placeholder="Contoh. Detail Produk"
                hide-details

                v-model="item.detail"
                :success="valid"
                :error-messages="errors"
                required
                class="mb-6"
                style="border-radius: 10px;">
                <template v-slot:append-outer>
                  <div v-if="errors.length > 0">
                    <v-tooltip top color="#ff5252">
                      <template v-slot:activator="{ on }">
                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                      </template>
                      
                      Detail Produk {{ errors[0] }}
                    </v-tooltip>
                  </div>

                  <div v-if="item.detail !== '' && valid">
                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                  </div>
                </template>
              </v-text-field>
            </ValidationProvider>

            <ValidationProvider 
              name="Qty" 
              rules="required" 
              v-slot="{ errors, valid }">
              <div class="body-2 mb-2">
                <span class="red--text">*</span>
                Qty
                <span class="error--text">
                  (wajib diisi)
                </span>
              </div>
              
              <v-currency-field
                filled
                rounded
                dense
                :color="set_color"
                
                placeholder="Contoh. 10"
                hide-details

                v-model="item.qty"
                :success="valid"
                :error-messages="errors"
                required
                class="mb-6"
                style="border-radius: 10px;">
                <template v-slot:append-outer>
                  <div v-if="errors.length > 0">
                    <v-tooltip top color="#ff5252">
                      <template v-slot:activator="{ on }">
                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                      </template>
                      
                      Qty {{ errors[0] }}
                    </v-tooltip>
                  </div>

                  <div v-if="item.qty !== '' && valid">
                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                  </div>
                </template>
              </v-currency-field>
            </ValidationProvider>

            <ValidationProvider 
              name="Satuan" 
              rules="required" 
              v-slot="{ errors, valid }">
              <div class="body-2 mb-2">
                <span class="red--text">*</span>
                Satuan
                <span class="error--text">
                  (wajib diisi)
                </span>
              </div>
              
              <v-text-field
                filled
                rounded
                dense
                :color="set_color"
                
                placeholder="Contoh. pcs"
                hide-details

                v-model="item.sat"
                :success="valid"
                :error-messages="errors"
                required
                class="mb-6"
                style="border-radius: 10px;">
                <template v-slot:append-outer>
                  <div v-if="errors.length > 0">
                    <v-tooltip top color="#ff5252">
                      <template v-slot:activator="{ on }">
                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                      </template>
                      
                      Satuan {{ errors[0] }}
                    </v-tooltip>
                  </div>

                  <div v-if="item.sat !== '' && valid">
                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                  </div>
                </template>
              </v-text-field>
            </ValidationProvider>

            <ValidationProvider 
              name="Harga" 
              rules="required" 
              v-slot="{ errors, valid }">
              <div class="body-2 mb-2">
                <span class="red--text">*</span>
                Harga
                <span class="error--text">
                  (wajib diisi)
                </span>
              </div>
              
              <v-currency-field
                filled
                rounded
                dense
                :color="set_color"
                
                placeholder="Contoh. 10000"
                hide-details

                v-model="item.harga"
                :success="valid"
                :error-messages="errors"
                required
                class="mb-6"
                style="border-radius: 10px;">
                <template v-slot:append-outer>
                  <div v-if="errors.length > 0">
                    <v-tooltip top color="#ff5252">
                      <template v-slot:activator="{ on }">
                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                      </template>
                      
                      Harga {{ errors[0] }}
                    </v-tooltip>
                  </div>

                  <div v-if="item.harga !== '' && valid">
                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                  </div>
                </template>
              </v-currency-field>
            </ValidationProvider>

          </v-card>
        </div>

        <div>
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Tanggal
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>

          <v-menu
            ref="tanggal"
            min-width="290px"
            max-width="290px"
            transition="scale-transition"
            offset-y
            :nudge-right="40"
            :close-on-content-click="false"
            v-model="picker.tanggal">
            <template v-slot:activator="{ on, attrs }">
              <ValidationProvider 
                name="Tanggal" 
                rules="required"
                v-slot="{ errors, valid }">
                <v-text-field
                  readonly
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Pilih Tanggal"
                  hide-details
                  clearable

                  @click:clear="form.template_meta_json_object.tanggal = null;"
                  v-on="on"
                  v-bind="attrs"

                  v-model="form.template_meta_json_object.tanggal"
                  :success="form.template_meta_json_object.tanggal !== null && valid"
                  :error-messages="errors"
                  class="mb-6"
                  style="border-radius: 10px; width: 40%;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Tanggal {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.template_meta_json_object.tanggal !== null && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </template>

            <v-date-picker 
              :color="set_color"
              v-model="form.template_meta_json_object.tanggal"
              @input="picker.tanggal = false">
            </v-date-picker>
          </v-menu>
        </div>

        <ValidationProvider 
          name="Catatan" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Catatan
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-textarea
            filled
            rounded
            dense
            :color="set_color"

            rows="3"
            
            placeholder="Contoh. Catatan"
            hide-details

            v-model="form.template_meta_json_object.catatan"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Catatan {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.catatan !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-textarea>
        </ValidationProvider>

        <ValidationProvider 
          name="Penerima" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Penerima
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. penerima"
            hide-details

            v-model="form.template_meta_json_object.nama_penerima"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Penerima {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.nama_penerima !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>

        <ValidationProvider 
          name="Admin Unit Bisnis" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Admin Unit Bisnis
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. Admin Unit Bisnis."
            hide-details

            v-model="form.template_meta_json_object.nama_admin"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Admin Unit Bisnis {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.nama_admin !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        md="6">
        <v-card
          flat
          style="border: 2px solid #f0f0f0; border-radius: 10px; position: sticky; top: 12px;">
          <div
            ref="arsippdf"
            style="padding: 50px;">
            <v-card-text
              class="black--text py-2">
              <div class="text-center body-1 font-weight-bold mb-5">
                Surat Jalan Pesanan
              </div>
              <v-row>
                <v-col cols="12" md="7" style="font-size: 13px;">
                  <v-row>
                    <v-col
                      cols="12"
                      md="4"
                      class="py-0 pr-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      Nama Pemesan
                    </v-col>

                    <v-col
                      cols="12"
                      md="8"
                      class="py-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      : {{ form.template_meta_json_object.nama_pesanan !== '' ? form.template_meta_json_object.nama_pesanan : '__________' }}
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="12"
                      md="4"
                      class="py-0 pr-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      Unit Pemesan
                    </v-col>

                    <v-col
                      cols="12"
                      md="8"
                      class="py-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      : {{ form.template_meta_json_object.unit !== '' ? form.template_meta_json_object.unit : '__________' }}
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="12"
                      md="4"
                      class="py-0 pr-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      Tanggal Pengantaran
                    </v-col>

                    <v-col
                      cols="12"
                      md="8"
                      class="py-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      :
                      <span v-if="form.template_meta_json_object.tanggal_pengantaran !== '' && form.template_meta_json_object.tanggal_pengantaran !== null">
                        {{ form.template_meta_json_object.tanggal_pengantaran | weekday }}, {{ form.template_meta_json_object.tanggal_pengantaran | fulldate }}
                      </span>
                      <span v-else>
                        ___________________________
                      </span>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12" md="5" style="font-size: 13px;">
                  <v-row>
                    <v-col
                      cols="12"
                      md="7"
                      class="py-0 px-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      Waktu Pengantaran
                    </v-col>

                    <v-col
                      cols="12"
                      md="5"
                      class="py-0 pl-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      : {{ form.template_meta_json_object.waktu_pengantaran !== '' ? form.template_meta_json_object.waktu_pengantaran : '__________' }}
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="12"
                      md="7"
                      class="py-0 px-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      Tempat Pengantaran
                    </v-col>

                    <v-col
                      cols="12"
                      md="5"
                      class="py-0 pl-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      : {{ form.template_meta_json_object.tempat_pengantaran !== '' ? form.template_meta_json_object.tempat_pengantaran : '__________' }}
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="12"
                      md="7"
                      class="py-0 px-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      No. Hp / Telp
                    </v-col>

                    <v-col
                      cols="12"
                      md="5"
                      class="py-0 pl-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      : {{ form.template_meta_json_object.no_telepon !== '' ? form.template_meta_json_object.no_telepon : '__________' }}
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <div
                class="mt-8"
                style="margin-top: 8px !important;">

                <table style="border-collapse: collapse; width: 100%;">
                  <tr>
                    <th style="font-size: 13px; border: 1px solid #ddd; padding: 8px; text-align: center; width: 1px; white-space: nowrap;">
                      No
                    </th>
                    <th style="font-size: 13px; border: 1px solid #ddd; padding: 8px; text-align: center; width: 1px; white-space: nowrap;">
                      Nama Produk
                    </th>
                    <th style="font-size: 13px; border: 1px solid #ddd; padding: 8px; text-align: center; width: 1px; white-space: nowrap;">
                      Detail Produk
                    </th>
                    <th style="font-size: 13px; border: 1px solid #ddd; padding: 8px; text-align: center; width: 1px; white-space: nowrap;">
                      Qty
                    </th>
                    <th style="font-size: 13px; border: 1px solid #ddd; padding: 8px; text-align: center; width: 1px; white-space: nowrap;">
                      Sat
                    </th>
                    <th style="font-size: 13px; border: 1px solid #ddd; padding: 8px; text-align: center; width: 1px; white-space: nowrap;">
                      Harga
                    </th>
                    <th style="font-size: 13px; border: 1px solid #ddd; padding: 8px; text-align: center; width: 1px; white-space: nowrap;">
                      Jumlah
                    </th>
                  </tr>

                  <tr v-for="(item, index) in form.template_meta_json_object.item" :key="index">
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 8px; text-align: center;">
                      {{ index + 1 }}
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 8px; text-align: left;">
                      {{ item.nama }}
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 8px; text-align: left;">
                      {{ item.detail }}
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 8px; text-align: left; width: 1px; white-space: nowrap;">
                      
                      <span v-if="item.qty !== '' && item.qty !== null">
                        {{ item.qty | number }}
                      </span>
                      <span v-else>
                        
                      </span>
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 8px; text-align: left;">
                      {{ item.sat }}
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 8px; text-align: left; width: 1px; white-space: nowrap;">
                      
                      <span v-if="item.harga !== '' && item.harga !== null">
                        Rp. {{ item.harga | number }}
                      </span>
                      <span v-else>
                        
                      </span>
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 8px; text-align: left; width: 1px; white-space: nowrap;">
                      Rp. 
                      <span v-if="item.harga !== '' && item.harga !== null && item.qty !== '' && item.qty !== null">
                        {{ item.qty*item.harga | number }}
                      </span>
                      <span v-else>
                        
                      </span>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="6" style="font-size: 12px; border: 1px solid #ddd; padding: 8px; text-align: left;">
                      Total
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ddd; padding: 8px; text-align: left;">
                      <!-- Rp. {{ form.template_meta_json_object.item.reduce((acc, item) => formatPrice(((item.qty*item.harga*1)++)), 0) }} -->
                       Rp. {{ 
                        formatPrice(form.template_meta_json_object.item.map(item => item.qty*item.harga).reduce((acc, item) => acc + item, 0))
                        }}
                    </td>
                  </tr>

                </table>

                <div
                  class="mb-4 mt-2"
                  style="margin-bottom: 16px !important;">
                  Catatan : {{ form.template_meta_json_object.catatan !== '' ? form.template_meta_json_object.catatan : '__________' }}
                </div>

              </div>

              <v-row
                class="mt-8"
                style="display: flex; flex-wrap: wrap; flex: 1 1 auto; justify-content: flex-end !important; margin-top: 32px !important;">
                <v-col
                  cols="12"
                  md="6"
                  class="text-center"
                  style="text-align: center !important;">
                  <div>
                    Penerima
                  </div>

                  <div class="mt-16">
                    {{ form.template_meta_json_object.nama_penerima !== '' ? form.template_meta_json_object.nama_penerima : '__________' }}
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                  class="text-center"
                  style="text-align: center !important;">
                  <div>
                    Admin Unit Bisnis
                  </div>

                  <div class="mt-16">
                    {{ form.template_meta_json_object.nama_admin !== '' ? form.template_meta_json_object.nama_admin : '__________' }}
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  import { TokenService } from "@/service/Storage.Service";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  import html2pdf from 'html2pdf.js'
import { ValidationObserver, ValidationProvider } from "vee-validate";
  export default {
    props: {
      form: {
        type: Object,
        default: {}
      },
      units: {
        type: Array,
        default: []
      },
      process: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        picker: {
          expired: false,
          tanggal: false,
          tanggal_mulai: false,
          tanggal_selesai: false,
          tanggal_masuk: false,

          range: false
        },

        time: {
          pukul: false
        },
      }
    },
    components: {
      
    },
    watch: {

    },
    computed: {
      user () {
        return this.$store.state.user
      },
      
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb_soft () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },

      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },

      // formattedDate: {
      //   get () {
      //     return (this.form.template_meta_json_object.tanggal && this.form.template_meta_json_object.tanggal.length === 10) ? moment(this.form.template_meta_json_object.tanggal).format('DD MMMM YYYY') : this.form.template_meta_json_object.tanggal
      //   },
      //   set (newValue) {
      //     if (newValue && newValue.length == 10) {
      //         let newDate = `${newValue.substring(6, 10)}-${newValue.substring(3, 5)}-${newValue.substring(0, 2)}`
      //         this.form.template_meta_json_object.tanggal = newDate
      //     }
      //   }
      // },

      date_range () {
        return this.filter.dates.join(' s/d ')
      }
    },
    mounted () {
      
    },
    methods: {
      formatPrice(value) {
        if (isNaN(value)) return "Not a Number"
        let number = ""
        const reverseNumber = value
          .toString()
          .split("")
          .reverse()
          .join("")
        const arrReverseNumber = [...Array(reverseNumber.length).keys()]
        arrReverseNumber.map(index => {
          if (index % 3 === 0) number += reverseNumber.substr(index, 3) + "."
        })

        return `${
          number.split("", number.length - 1)
          .reverse()
          .join("")
        }`
      },
      add_pegawai () {
        this.form.template_meta_json_object.kepada.push({
          nama: '',
          unit: ''
        })
      },
      add_desc () {
        this.form.template_meta_json_object.deskripsi.push({
          text: ''
        })
      },
      add_tugas () {
        this.form.template_meta_json_object.tugas.push({
          text: ''
        })
      },
      add_item () {
        this.form.template_meta_json_object.item.push({
          nama: '',
          detail: '',
          qty: '',
          sat: '',
          harga: ''
        })
      },
    }
  }
</script>

<style>